/**
 * SignedLoadmore JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class SignedLoadmore
 */
class SignedLoadmore {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {

    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        // Get the Initiative compare section
        this.signedPage = $( '.signed-page' );

        // Get the signatures section
        this.signaturesSection = this.signedPage.find( '.signed__signed-by' );
        this.signature = this.signedPage.find( '.signed__signed-by__name' );

        // Get the show more button
        this.seeMoreButton = this.signedPage.find( '#signed__show-more' );

    }

    /**
     * All common events
     * @return {void}
     */
    events() {
        var loadamount = 100;
        var loaditeration = 2; // Starts at two to account for the initial load

        // Show the initial values on load
        this.signature.slice( 0, loadamount ).show();

        // If there are more names to show on initial load, show the load more button
        if ( $( ':hidden', this.signaturesSection ).length != 0 ) {
            this.seeMoreButton.css( 'display', 'inline-block' );
        }

        // On button click...
        this.seeMoreButton.on( 'click', ( e ) => {

            Theme.Common.stop( e );

            // Reveal the next batch of names
            this.signature.slice( 0, ( loadamount * loaditeration++ ) ).fadeIn( 'slow' );

            // Hide the button once there are no more names to show.
            if ( $( ':hidden', this.signaturesSection ).length == 0 ) {
                this.seeMoreButton.fadeOut( 'slow' );
            }

        });

    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
    }
}

// Export the class reference.
module.exports = SignedLoadmore;



// WEBPACK FOOTER //
// ./assets/scripts/signed-loadmore.js